export const OrderSummaryLoader = () => (
  <div className="flex flex-col lg:flex-row justify-between items-center w-full animate-pulse">
    <div className="min-h-[900px] rounded-lg bg-grey-scale-coin w-full"></div>
  </div>
);
